export const SYSTEM_ERROR = {
  UNKNOWN: 'An error occurred in the system. Please try again later.',
  TIMEOUT: 'The connection timed out. Please try again later.'
}

export const GUIDE_LINK = {
  CREATE_PATH_DATA: 'https://guide.raksul.com/hc/ja/articles/6235342324623-%E3%83%91%E3%82%B9%E3%83%87%E3%83%BC%E3%82%BF%E3%81%AE%E4%BD%9C%E6%88%90%E6%96%B9%E6%B3%95'
}
